import { translate } from '/b2b/common/helpers/i18n';

const ANALYTICS = 'ANALYTICS';
const BLOCKLISTED = 'BLACKLISTED'; // TODO: webservices should be updated to remove this outdated term
const ESSENTIAL = 'ESSENTIAL';
const HIDDEN = 'HIDDEN';
const MARKETING = 'MARKETING';
const PERSONALIZATION = 'PERSONALIZATION';

// Values
export const CLASSIFICATIONS = {
    ANALYTICS,
    BLOCKLISTED,
    ESSENTIAL,
    HIDDEN,
    MARKETING,
    PERSONALIZATION,
};

// Labels
export const CLASSIFICATION_LABELS = {
    [ANALYTICS]: 'common.fields.classifications.analytics',
    [ESSENTIAL]: 'common.fields.classifications.essential',
    [MARKETING]: 'common.fields.classifications.marketing',
    [PERSONALIZATION]: 'common.fields.classifications.personalization',
    [BLOCKLISTED]: 'common.fields.classifications.blocklisted',
    [HIDDEN]: 'common.fields.classifications.hidden',
};

export const translateClassification = value => translate(CLASSIFICATION_LABELS[value] || value);

const classificationOptions = Object.entries(CLASSIFICATION_LABELS).map(([value, label]) => ({
    value,
    label,
}));

export default classificationOptions;
